/*eslint-disable*/
export default function checkConfig(config: any) {
  if (!config) throw new TypeError('Stats.init() config不能为空！');
  if (!config.hasOwnProperty('system_code')) throw new TypeError('Stats.init() system_code系统编码不能为空！');
  if (!config.hasOwnProperty('product_code')) throw new TypeError('Stats.init() product_code项目编码不能为空！');
  if (!config.hasOwnProperty('platform_env')) throw new TypeError('Stats.init() platform_env平台环境不能为空');
}
